import { Component, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.less']
})
export class FilePreviewComponent implements OnDestroy {
  @Input() set attachmentId(id: any) {
    if (id) this.openPreview(id);
  }

  visible = false;
  loading = false;
  filename = '';
  fileType: 'image' | 'pdf' | 'other' = 'other';
  previewUrl: string | SafeResourceUrl | null = null;
  private objectUrl: string | null = null;

  private get downloadUrl(): string {
    return `${environment.baseUrl}${environment.wso2amEndPoint}/dms${environment.wso2amApiVersion}/api/v1/attachments`;
  }

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private notify: NzNotificationService
  ) {}

  openPreview(id: any): void {
    this.visible = true;
    this.loading = true;
    this.previewUrl = null;

    this.http.get(`${this.downloadUrl}/${id}/download`, { responseType: 'blob', observe: 'response' }).subscribe({
      next: (res) => {
        const blob = res.body!;
        const disposition = res.headers?.get('content-disposition') ?? '';
        const match = disposition.match(/filename="?([^"]+)"?/);
        this.filename = match?.[1] ?? `attachment-${id}`;
        const ext = this.filename.split('.').pop()?.toLowerCase() ?? '';
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = URL.createObjectURL(blob);
        this.fileType = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext) ? 'image'
          : ext === 'pdf' ? 'pdf' : 'other';
        this.previewUrl = this.fileType === 'pdf'
          ? this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl)
          : this.objectUrl;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.visible = false;
        this.notify.error('Error', err?.error?.message ?? 'Failed to load preview');
      }
    });
  }

  close(): void {
    this.visible = false;
    this.previewUrl = null;
  }

  download(): void {
    if (!this.objectUrl) return;
    const a = document.createElement('a');
    a.href = this.objectUrl;
    a.download = this.filename;
    a.click();
  }

  ngOnDestroy(): void {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
  }
}
